<template>
	<div class="chat-dialog-overlays">
		<chat-pinned-messages-dialog
			v-if="pinnedMounted"
			:visible="showTopMessageDialog"
			:loading="topMessageLoading"
			:top-message-list="topMessageList"
			:can-manage="canManageTopMessages"
			:removing-id="topMessageRemovingId"
			:head-image="headImage"
			:show-name="showName"
			@update:visible="$emit('update:show-top-message-dialog', $event)"
			@locate="$emit('locate-top-message', $event)"
			@remove="$emit('remove-top-message', $event)"
		></chat-pinned-messages-dialog>
		<chat-record v-if="recordMounted" :visible="showRecord" @close="$emit('close-record')"
			@send="$emit('send-record', $event)"></chat-record>
		<chat-selector v-if="chatSelectorMounted" ref="chatSel" title="转发消息"
			:enable-friend-groups="true"></chat-selector>
		<rtc-group-join v-if="isGroup && rtcJoinMounted" ref="rtcJoin" :groupId="group.id"></rtc-group-join>
		<chat-history
			v-if="historyMounted"
			ref="chatHistory"
			:chat="chat"
			:friend="friend"
			:group="group"
			:groupMembers="groupMembers"
			@locateQuote="$emit('locate-quote', $event)"
		></chat-history>
	</div>
</template>

<script>
import RtcGroupJoin from "../rtc/RtcGroupJoin.vue";
import ChatHistory from "./ChatHistory.vue";
import ChatPinnedMessagesDialog from "./ChatPinnedMessagesDialog.vue";
import ChatRecord from "./ChatRecord.vue";
import ChatSelector from "./ChatSelector.vue";

export default {
	name: "chatDialogOverlays",
	components: {
		RtcGroupJoin,
		ChatHistory,
		ChatPinnedMessagesDialog,
		ChatRecord,
		ChatSelector
	},
	props: {
		chat: {
			type: Object,
			default: () => ({})
		},
		friend: {
			type: Object,
			default: () => ({})
		},
		group: {
			type: Object,
			default: () => ({})
		},
		groupMembers: {
			type: Array,
			default: () => []
		},
		headImage: {
			type: Function,
			default: () => ""
		},
		isGroup: {
			type: Boolean,
			default: false
		},
		showName: {
			type: Function,
			default: () => ""
		},
		showRecord: {
			type: Boolean,
			default: false
		},
		showTopMessageDialog: {
			type: Boolean,
			default: false
		},
		topMessageList: {
			type: Array,
			default: () => []
		},
		topMessageLoading: {
			type: Boolean,
			default: false
		},
		canManageTopMessages: {
			type: Boolean,
			default: false
		},
		topMessageRemovingId: {
			type: [Number, String],
			default: null
		}
	},
	data() {
		return {
			pinnedMounted: Boolean(this.showTopMessageDialog),
			recordMounted: Boolean(this.showRecord),
			chatSelectorMounted: false,
			rtcJoinMounted: false,
			historyMounted: false
		};
	},
	watch: {
		showTopMessageDialog(value) {
			if (value) this.pinnedMounted = true;
		},
		showRecord(value) {
			if (value) this.recordMounted = true;
		}
	},
	methods: {
		ensureMounted(key) {
			if (!this[key]) {
				this[key] = true;
				return this.$nextTick();
			}
			return Promise.resolve();
		},
		openChatSelector(callback) {
			return this.ensureMounted('chatSelectorMounted').then(() => {
				if (this.$refs.chatSel) this.$refs.chatSel.open(callback);
			});
		},
		openRtcJoin(rtcInfo) {
			return this.ensureMounted('rtcJoinMounted').then(() => {
				if (this.$refs.rtcJoin) this.$refs.rtcJoin.open(rtcInfo);
			});
		},
		openHistory() {
			return this.ensureMounted('historyMounted').then(() => {
				if (this.$refs.chatHistory) return this.$refs.chatHistory.open();
				return null;
			});
		},
		closeHistory() {
			if (this.$refs.chatHistory) {
				this.$refs.chatHistory.close();
			}
		}
	}
}
</script>
